import { FC } from 'react'
import { Chip, Spinner } from '@material-tailwind/react'
import { useLabelsContext } from '../contexts/LabelsContext'
import { useDarkMode } from '../contexts/DarkModeContext'

interface AgamiTypeChipProps {
  agamiType: number
}

const AgamiTypeChip: FC<AgamiTypeChipProps> = ({ agamiType }) => {
  const { loading, getSpotTypeLabel } = useLabelsContext()
  const { darkMode } = useDarkMode()
  return (
    <Chip
      className="inline-block"
      size="sm"
      variant={darkMode ? 'filled' : 'ghost'}
      color={agamiType === 1 ? 'brown' : 'blue-gray'}
      data-testid="agami-type-chip"
      data-spot-type={agamiType}
      value={
        loading ? (
          <span className="inline-block">
            <Spinner className="w-2 h-2" />
          </span>
        ) : (
          (getSpotTypeLabel(agamiType) ?? 'Unknown')
        )
      }
    />
  )
}

export default AgamiTypeChip
